import React, { useState, useEffect } from 'react';
import { searchReminders } from '../../../services/Reminders';
import Template from '../../../components/organisms/Template';
import { Row, Button, Container, ButtonGroup } from 'react-bootstrap';
import { FaPlusCircle, FaSync, FaColumns, FaSearch } from 'react-icons/fa';
import { useAlert } from 'react-alert';
import Table from '../../../components/atoms/Table';
import { formatDate } from '../../../helpers/functions';
import { optionsFormatter, rowFormatter } from '../../../helpers/tableFunctions';
import PageHeader from '../../../components/molecules/PageHeader';
import ModalSelectColumns from '../../../components/organisms/ModalSelectColumns';
import ModalSearchReminders from '../../../components/organisms/ModalSearchReminders';

function List() {

  const [loading, setLoading] = useState(true);
  const [searchModalShow, setSearchModalShow] = useState(false);
  const [reminders, setReminders] = useState([]);
  const alert = useAlert();

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const result = await searchReminders({ dataHoraInicio: new Date() }, alert);
      if (result) {
        setReminders(result);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const refresh = async () => {
    setLoading(true);
    const result = await searchReminders({ dataHoraInicio: new Date() }, alert);
    if (result) {
      setReminders(result);
      alert.success('Lista atualizada');
    }
    setLoading(false);
  };

  const search = async (searchBody) => {
    setLoading(true);
    const result = await searchReminders(searchBody, alert);
    if (result) {
      setReminders(result);
    }
    setSearchModalShow(false);
    setLoading(false);
  };

  const initialColumnsProps = {
    data: { name: 'Data', visibility: true },
    nota: { name: 'Notas', visibility: true },
    responsavel: { name: 'Responsável', visibility: false },
  };

  const [columnsProps, setColumnsProps] = useState(initialColumnsProps);
  const [selectColumnsModalShow, setSelectColumnsModalShow] = useState(false);

  const remindersColumn = [
    {
      dataField: '_id', text: '#',
      formatter: (cell, row, rowIndex) => (<>{rowFormatter(rowIndex, reminders, row)}</>)
    },
    {
      dataField: 'data', text: columnsProps['data'].name, sort: true,
      hidden: !columnsProps['data'].visibility,
      formatter: (cell) => (<>{formatDate(cell)}</>),
    },
    {
      dataField: 'nota', text: columnsProps['nota'].name, sort: true,
      hidden: !columnsProps['nota'].visibility,
    },
    {
      dataField: 'responsavel.nome', text: columnsProps['responsavel'].name, sort: true,
      hidden: !columnsProps['responsavel'].visibility,
    },
    {
      dataField: '_id', text: 'Opções',
      formatter: (cell) => (<>{optionsFormatter(cell, 'reminder')}</>),
    }
  ];

  return (
    <Template loading={loading}>
      <PageHeader tittle="Lembretes">
        <ButtonGroup className="float-right">
          <Button variant="success" href="/reminder/new">
            <FaPlusCircle />
          </Button>
          <Button variant="primary" onClick={() => refresh()}>
            <FaSync />
          </Button>
          <Button variant="dark" onClick={() => setSearchModalShow(true)}>
            <FaSearch />
          </Button>
          <Button variant="secondary" onClick={() => setSelectColumnsModalShow(true)}>
            <FaColumns />
          </Button>
        </ButtonGroup>
      </PageHeader>
      <Row>
        <Container className="container container-nobars">
          <Table data={reminders} columns={remindersColumn} keyField='_id'
            defaultSorted={[{ dataField: 'data', order: 'asc' }]} />
        </Container>
      </Row>
      <ModalSearchReminders show={searchModalShow}
        onHide={() => setSearchModalShow(false)} searchFunction={(searchBody) => search(searchBody)} />
      <ModalSelectColumns show={selectColumnsModalShow} columnsProps={columnsProps}
        setColumnsProps={setColumnsProps} initialColumnsProps={initialColumnsProps}
        onHide={() => setSelectColumnsModalShow(false)} />
    </Template>
  );
}

export default List;